export interface ScrollIndicatorState {
  canScrollUp: boolean
  canScrollDown: boolean
}

interface ScrollIndicatorOptions {
  visible: boolean
  onChange: (state: ScrollIndicatorState) => void
}

export function scrollIndicators(node: HTMLElement, opts: ScrollIndicatorOptions) {
  function recompute() {
    const rect = node.getBoundingClientRect()
    if (rect.height > 0) {
      const maxHeight = window.innerHeight - rect.top - 16
      node.style.maxHeight = `${Math.max(maxHeight, 200)}px`
    }

    opts.onChange({
      canScrollUp: node.scrollTop > 1,
      canScrollDown: node.scrollTop + node.clientHeight < node.scrollHeight - 1,
    })
  }

  function recomputeSoon() {
    requestAnimationFrame(recompute)
  }

  node.addEventListener('scroll', recompute, { passive: true })
  window.addEventListener('resize', recomputeSoon)

  if (opts.visible) {
    recomputeSoon()
  }

  return {
    update(newOpts: ScrollIndicatorOptions) {
      const becameVisible = newOpts.visible && !opts.visible
      opts = newOpts
      if (becameVisible) {
        recomputeSoon()
      }
    },
    destroy() {
      node.removeEventListener('scroll', recompute)
      window.removeEventListener('resize', recomputeSoon)
    },
  }
}
